import * as React from 'react';


export default class Arrow extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg viewBox='0 0 12 12' className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <g id="exzeo_2.x_icon_set" fillRule="evenodd" transform="translate(-318.000000, -225.000000)">
            <g id="Group-76" transform="translate(318.000000, 225.000000)">
                <polyline id="Path-5" strokeWidth=" " points="4 6 7.77910438 9.77910438 12 6"></polyline>
                <g id="Group-75"></g>
            </g>
        </g>
      </svg>
    )
  }
}
